import { ThemeBus } from "./events-bus.js";
import { EVENTS } from "./event-constants.js";

const STORAGE_KEY = "theme:collection-mobile-grid-cols";
const ACTIVE_BTN_CLASS = "bg-secondary";
const GRID_SELECTOR = "[data-product-grid].product-grid-container";
const CARD_SELECTOR = "[data-collection-grid-item='true'].product-card";
const SWITCH_SELECTOR = "[data-filter-grid-switch]";

function isTwoColumns(raw) {
    return raw === "true";
}

function readStoredPreference() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (v === "1" || v === "2") return v === "2";
    } catch (_) {}
    return null;
}

function applyGridColumns(twoColumns) {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        card.classList.toggle("col-span-2", !twoColumns);
        card.classList.toggle("col-span-1", twoColumns);
    });
}

function syncSwitchUI(twoColumns) {
    document.querySelectorAll(SWITCH_SELECTOR).forEach((root) => {
        root.querySelectorAll("button[data-filter-grid]").forEach((btn) => {
            const on = isTwoColumns(btn.dataset.filterGrid) == twoColumns;
            btn.classList.toggle(ACTIVE_BTN_CLASS, on);
            btn.setAttribute("aria-pressed", on ? "true" : "false");
        });
    });
}

function setMobileGridColumns(twoColumns, { persist = true} = {}) {
    applyGridColumns(twoColumns);
    syncSwitchUI(twoColumns);
    if (persist) {
        try {
            localStorage.setItem(STORAGE_KEY, twoColumns ? "2" : "1");
        } catch (_) {}
    }
}

function initMobileGridSwitch() {
    const stored = readStoredPreference();
    if (stored !== null) {
      setMobileGridColumns(stored, { persist: false });
    } else {
      syncSwitchUI(true);
    }
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(`${SWITCH_SELECTOR} button[data-filter-grid]`);
      if (!btn) return;
      e.preventDefault();
      setMobileGridColumns(isTwoColumns(btn.dataset.filterGrid));
    });
  }
  function reapplyAfterGridSwap() {
    const stored = readStoredPreference();
    if (stored !== null) setMobileGridColumns(stored, { persist: false });
  }
  if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initMobileGridSwitch);
    } else {
      initMobileGridSwitch();
    }
    ThemeBus?.addEventListener(EVENTS.gridUpdated, reapplyAfterGridSwap);
    ThemeBus?.addEventListener(EVENTS.filtersUpdated, reapplyAfterGridSwap);
  }